export enum RequestType {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
}

export enum ErrorCodes {
  API = 'API_ERROR',
  UI = 'UI_ERROR',
  STATE = 'STATE_ERROR',
  SECURITY = 'SECURITY_ERROR',
  GLOBAL = 'GLOBAL_ERROR',
  UNHANDLED_PROMISE = 'UNHANDLED_PROMISE_REJECTION',
}

export enum StreamTypes {
  ASTHMA = 'Asthma',
  CAD = 'CAD',
  COPD = 'COPD',
  DIABETES = 'Diabetes',
  EXERCISE = 'Exercise',
  HEARTHFAILURE = 'HeartFailure',
  HIGHBOOLPRESSURE = 'HighBloodPressure',
  HIGHCHOLESTEROL = 'HighCholesterol',
  NUTRITION = 'Nutrition',
  SLEEP = 'Sleep',
  STRESS = 'Stress',
  TOBACCO = 'Tobacco',
  WEIGHT = 'Weight',
}

export enum ApiEndpoints {
  INTERESTS = 'api/interests',
  DEVICES = 'api/devices',
  PROFILE = 'api/user',
  PROMO_BANNER = 'api/promoBanner',
  REWARDS = 'api/rewards',
  CHALLENGES = 'api/challenges',
  CARDS_ACTIVITIES = 'api/cards',
  DAILY_HABITS = 'api/dailyHabits',
  HOME_WIDGET_TEXT = 'api/homeWidgetText',
  SIGN_IN_WITH_KEY = 'api/auth/tempSignIn',
  HEALTH_TRACKERS = 'api/healthtrackers',
  HEALTH_GOALS = 'api/healthGoals',
}

export enum CardTemplate {
  TEXT_ONLY = 'Text Only',
  FULL_IMAGE = 'Full Image',
  HALF_IMAGE = 'Half Image',
  RIGHT_SIDE_IMAGE = 'Right Side Image',
  FULL_COLOR = 'Full Color',
  CHALLENGES = 'Challenges',
  STEP_BATTLE = 'StepBattle',
  RIGHT_SIDE_VIDEO = 'Right Side Video',
  DAILY_HABITS = 'Daily Habits',
}

export enum LinkBehavior {
  OpenUrl = 'OpenUrl',
  OpenTextModal = 'OpenTextModal',
  None = 'None',
}

export enum ChallengeTypes {
  Steps = 'Steps',
  Exercise = 'Exercise',
  Nutrition = 'Nutrition',
  Sleep = 'Sleep',
  Stress = 'Stress',
  Water = 'Water',
  Custom = 'Custom',
  StepBattle = 'StepBattle',
}

export enum ProgramType {
  ClassicAction = 'Classic Action',
  CumulativePoints = 'Cumulative Points',
}

export enum AvailabilityState {
  NotAvailableYet = 'NotAvailableYet',
  Available = 'Available',
  Completed = 'Completed',
  Expired = 'Expired',
}

export enum AvailabilityFlair {
  None = 'None',
  ComingSoon = 'ComingSoon',
  New = 'New',
  ExpiringSoon = 'ExpiringSoon',
}

export enum GatewayRequirementState {
  NoGatewayRequirements = 'NoGatewayRequirements',
  RequirementsNotAvailableYet = 'RequirementsNotAvailableYet',
  RequirementsNotComplete = 'RequirementsNotComplete',
  RequirementsExpired = 'RequirementsExpired',
  RequirementsBypassed = 'RequirementsBypassed',
  RequirementsFailed = 'RequirementsFailed',
  RequirementsComplete = 'RequirementsComplete',
}
export enum DailyHabitPlanState {
  Completed = 'Completed',
  Failed = 'Failed',
  InProgress = 'InProgress',
}

export enum DailyHabitPlanStatus {
  AtRisk = 'yellow',
  OffTrack = 'red',
  OnTrack = 'green',
}

export enum DailyHabitTypes {
  Asthma = 'Asthma',
  BackHealth = 'BackHealth',
  BalancedLiving = 'BalancedLiving',
  CAD = 'CAD',
  COPD = 'COPD',
  CopeBlues = 'CopeBlues',
  Diabetes = 'Diabetes',
  Exercise = 'Exercise',
  HeartFailure = 'HeartFailure',
  Hypertension = 'Hypertension',
  MaternalHealthTrimester1 = 'MaternalHealthTrimester1',
  MaternalHealthTrimester2 = 'MaternalHealthTrimester2',
  MaternalHealthTrimester3 = 'MaternalHealthTrimester3',
  Nutrition = 'Nutrition',
  PregnantPartner = 'PregnantPartner',
  SleepWell = 'SleepWell',
  StayConnected = 'StayConnected',
  Stress = 'Stress',
  Tobacco = 'Tobacco',
  Weight = 'Weight',
  WorkLifeBalance = 'WorkLifeBalance',
}

export enum LogSeverity {
  VERBOSE = 1, // Debug logs, minor details
  INFORMATION = 2, // General system info
  WARNING = 3, // Potential issues, recoverable errors
  ERROR = 4, // Critical issues, exceptions
}

export enum RoutePaths {
  Dashboard = '/dashboard',
  SignIn = '/signin',
}

export enum ApplicationSource {
  HealthAssessment = 'Hra',
}

export enum MediaType {
  IMAGE,
  VIDEO,
}

export enum SpotlightLayoutType {
  TEXT_LEFT_MEDIA_RIGHT,
  FULL_SIZE,
}

export enum TrackerTypes {
  BloodPressure = 'bloodPressure',
  BreastSelfExam = 'breastSelfExam',
  PercentBodyFat = 'percentBodyFat',
  CaloriesBurned = 'caloriesBurned',
  Cholesterol = 'cholesterol',
  Triglycerides = 'triglycerides',
  ColorectalScreen = 'colorectalScreen',
  FootExam = 'footExam',
  ProstateCancerScreening = 'prostateCancerScreening',
  Diet = 'diet',
  Exercise = 'exercise',
  Steps = 'steps',
  EyeExam = 'eyeExam',
  FastingBloodSugar = 'fastingBloodSugar',
  NonFastingBloodSugar = 'nonFastingBloodSugar',
  HemoglobinA1C = 'hemoglobinA1C',
  ForcedExpiratoryVolume = 'forcedExpiratoryVolume',
  PeakExpiratoryFlow = 'peakExpiratoryFlow',
  Height = 'height',
  HighBloodSugar = 'highBloodSugar',
  SleepHours = 'sleepHours',
  LowBloodSugar = 'lowBloodSugar',
  Mammogram = 'mammogram',
  Medication = 'medication',
  MindfulnessMinutes = 'mindfulnessMinutes',
  Mood = 'mood',
  Pain = 'pain',
  PapSmear = 'papSmear',
  RescueInhalerUse = 'rescueInhalerUse',
  RestingHeartRate = 'restingHeartRate',
  Stress = 'stress',
  TobaccoUse = 'tobaccoUse',
  UrineProtienLevel = 'urineProtienLevel',
  WaistMeasurement = 'waistMeasurement',
  Weight = 'weight',
}

export enum HealthGoalType {
  BiometricScreening = 'BiometricScreening',
  BiometricTest = 'BiometricTest',
  StepsGoal = 'StepsGoal',
  ExerciseGoal = 'ExerciseGoal',
  PreventiveTests = 'PreventiveTests',
  TrackingGoal = 'TrackingGoal',
  BiometricTestCurrent = 'BiometricTestCurrent',
}

export enum HealthGoalSection {
  Active = 'Active',
  Completed = 'Completed',
  Ended = 'Ended',
}

export enum HealthGoalRate {
  PerDay = 'PerDay',
  PerCalWeek = 'PerCalWeek',
  PerCalMonth = 'PerCalMonth',
  PerCalYear = 'PerCalYear',
  PerCalQuarter = 'PerCalQuarter',
  PerDateRange = 'EvaluationDateRange',
}

export enum CalculatedType {
  Cumulative = 'Cumulative',
  Average = 'Average',
}

export enum DataSourceTypes {
  SelfReported = 'SelfReported',
  Device = 'Device',
  DeviceCaptured = 'DeviceCaptured',
  DeviceNotValidated = 'DeviceNotValidated',
  ProfessionallySourced = 'ProfessionallySourced',
}

export enum BiometricTestType {
  BloodPressureCombined = 4,
  BloodPressureDiastolic = 5,
  BloodPressureSystolic = 6,
  BloodSugarCombined = 7,
  BloodSugarFasting = 8,
  BloodSugarNonFasting = 9,
  BMI = 10,
  CholesterolRatio = 11,
  HDLCholesterol = 12,
  HemoglobinA1c = 13,
  LDLCholesterol = 14,
  CotinineBloodDraw = 15,
  CotinineSalivaTest = 16,
  CotinineUrineTest = 17,
  CotinineGeneric = 18,
  TotalCholesterol = 19,
  Triglycerides = 20,
  BodyFatPercentage = 21,
  ColorectalCancerScreening = 22,
  Diet = 23,
  Height = 25,
  Mood = 26,
  ProstateCancerScreening = 27,
  PhysicalExamOrWellnessVisit = 28,
  CervicalCancerScreeningPapOnly = 30,
  Mammogram = 31,
  RestingHeartRate = 32,
  Stress = 33,
  WaistMeasurement = 34,
  Weight = 35,
  HoursOfSleep = 36,
  RetinalEyeExam = 37,
  CervicalCancerScreeningPapPlusHpv = 38,
  CervicalCancerScreening = 39,
  Colonoscopy = 40,
  CtColonography = 41,
  FlexibleSigmoidoscopy = 42,
  StoolBasedTest = 43,
  ColorectalFitDnaTesting = 44,
  PrenatalVisit = 45,
  PostpartumVisit = 46,
  ChlamydiaScreening = 47,
  DentalExam = 48,
  AnnualWellnessVisit = 49,
  DiabeticNephropathyScreening = 50,
  OsteoporosisScreening = 51,
  DiabeticA1c = 52,
  FluShot = 53,
  Covid19Immunization = 54,
  MindfulnessMinutesTest = 55,
  SkinCancerScreening = 56,
  DigitalBreastTomosynthesis = 57,
  BreastCancerScreening = 58,
  VisionExam = 59,
  NutritionCounseling = 60,
  BariumEnema = 61,
  PneumococcalVaccine = 62,
  ShinglesVaccine = 63,
  GlaucomaScreening = 64,
  BreastUltrasound = 65,
  MassageTherapy = 66,
  ChiropracticCare = 67,
  Acupuncture = 68,
  LungCancerScreening = 69,
  EVisit = 70,
  WellnessOrAwvExam = 71,
}

export enum IconTopicType {
  Advocate = 'Advocate',
  BalancedLiving = 'BalancedLiving',
  Exercise = 'Exercise',
  Group = 'Group',
  Nutrition = 'Nutrition',
  Sleep = 'Sleep',
  SocialWellbeing = 'SocialWellbeing',
  Stress = 'Stress',
  Weight = 'Weight',
}
